export default __webpack_public_path__ + "images/8421a12c2293697a45b6d8b27b347722-science.jpg";